import { Group, Image, Text } from '@mantine/core';

import { CHECK_ICON } from 'constants/app';
import classes from './index.module.css';

interface IIconValue {
  text: string;
}

const IconValue = ({
  text
}: IIconValue) => {
  return (
    <Group>
      <Image w='auto' h='auto' src={CHECK_ICON} />
      <Text className={classes.value}>{text}</Text>
    </Group>
  );
}

export default IconValue;